import styled from "styled-components";

export const TimeSpentReminderSelectorContainerBox = styled.div`
    margin-top: 1.5rem;
    width: 29rem;
`;